import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';
import { spaLoad } from 'components/spa-load';

export default class LiveTabs extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.checkIfItemIsSelected();

        if (this.refs.link) {
            this.refs.link.forEach((link) => {
                this.addListener(link, 'click', this.onLinkClick);
            });
        }
    }


    checkIfItemIsSelected = () => {
        if (!this.refs.link) return;

        this.clearSelection(this.refs.link);

        this.refs.link.forEach((link) => {
            if (link.getAttribute('href') === window.location.pathname) {
                link.classList.add('is-active');
            } else if (this.getAttribute(link, 'aliases')) {
                const aliases = JSON.parse(this.getAttribute(link, 'aliases'));
                Object.values(aliases).forEach((alias) => {
                    if (window.location.pathname.includes(alias)) {
                        link.classList.add('is-active');
                    }
                });
            }
        });
    };

    clearSelection(nodesArray) {
        nodesArray.forEach((node) => {
            if (node.classList.contains('is-active')) {
                node.classList.remove('is-active');
            }
        });
    }

    onLinkClick = (event) => {
        var ignoreSpa = event.currentTarget.getAttribute('data-ignore-spa') === 'true';
        
        if(!ignoreSpa){            
            if (!app.isEditMode) {
            spaLoad.updateContent(event.currentTarget.href);
            }      
            event.preventDefault();     
        };
    }
}
